import type { Decor, Rect } from '../world/mapdef';
import type { Ctx } from './paint';

/** Prop drawers contributed by feature packages (keys use the package prefix, e.g. `fam_plot0`). */
export type ObjDrawer = (c: Ctx, r: Rect, t: number) => void;
const objDrawers = new Map<string, ObjDrawer>();
const decorDrawers: ((c: Ctx, d: Decor, t: number) => boolean)[] = [];
export const ANIMATED_EXTRA = { obj: new Set<string>(), decor: new Set<string>() };

export function registerPropDrawers(o: {
  objects?: Record<string, ObjDrawer>;
  decor?: (c: Ctx, d: Decor, t: number) => boolean;
  animatedObjects?: string[];
  animatedDecor?: string[];
}): void {
  for (const [k, f] of Object.entries(o.objects ?? {})) objDrawers.set(k, f);
  if (o.decor) decorDrawers.push(o.decor);
  o.animatedObjects?.forEach((k) => ANIMATED_EXTRA.obj.add(k));
  o.animatedDecor?.forEach((k) => ANIMATED_EXTRA.decor.add(k));
}
const prefixDrawers: [string, ObjDrawer][] = [];
/** One drawer for every object whose id starts with `prefix`. */
export function registerObjectPrefixDrawer(prefix: string, f: ObjDrawer): void {
  prefixDrawers.push([prefix, f]);
}
export function extraObjDrawer(id: string): ObjDrawer | undefined {
  const exact = objDrawers.get(id);
  if (exact) return exact;
  for (const [p, f] of prefixDrawers) if (id.startsWith(p)) return f;
  return undefined;
}
export function drawExtraDecor(c: Ctx, d: Decor, t: number): boolean {
  return decorDrawers.some((f) => f(c, d, t));
}
